import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { ENTERPRISE_LINKS } from "../enterpriseLinks";

const inputClass =
  "ent-input h-12 w-full rounded-xl border bg-background px-4 text-base text-foreground outline-none transition-colors placeholder:text-muted-foreground focus-visible:ring-2 focus-visible:ring-ring/30";

/* Placeholder sign-in, as in v0: there is no enterprise client portal yet, so every
   attempt shows the "Username not found" message pointing to the enterprise inbox. */
export function ClientLoginForm() {
  const [error, setError] = useState(false);

  function handleSubmit(event) {
    event.preventDefault();
    setError(true);
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-5">
      <div className="flex flex-col gap-2">
        <label htmlFor="username" className="text-sm font-medium text-foreground">
          Username
        </label>
        <input
          id="username"
          name="username"
          type="text"
          autoComplete="username"
          required
          className={inputClass}
          onChange={() => setError(false)}
        />
      </div>
      <div className="flex flex-col gap-2">
        <label htmlFor="password" className="text-sm font-medium text-foreground">
          Password
        </label>
        <input
          id="password"
          name="password"
          type="password"
          autoComplete="current-password"
          required
          className={inputClass}
          onChange={() => setError(false)}
        />
      </div>

      <div aria-live="polite">
        {error && (
          <p role="alert" className="rounded-xl border border-destructive/30 bg-destructive/10 px-4 py-3 text-sm leading-relaxed text-destructive">
            Username not found. Contact{" "}
            <a href={`mailto:${ENTERPRISE_LINKS.contactEmail}`} className="font-semibold underline underline-offset-2">
              {ENTERPRISE_LINKS.contactEmail}
            </a>
          </p>
        )}
      </div>

      <button
        type="submit"
        className="inline-flex h-12 items-center justify-center gap-2 rounded-full bg-primary px-6 text-sm font-semibold text-primary-foreground transition-opacity hover:opacity-90"
      >
        Log In
        <ArrowRight className="size-4" aria-hidden="true" />
      </button>
    </form>
  );
}
